import React, { Component } from 'react';
import { Collapse, Button, CardBody, Card } from 'reactstrap';
import  styles from'./FAQ.module.scss';
import collapse from 'assets/img/duvidas.png';

class FAQ extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.toggle2 = this.toggle2.bind(this);
        this.toggle3 = this.toggle3.bind(this);
        this.toggle4 = this.toggle4.bind(this);
        this.toggle5 = this.toggle5.bind(this);
        this.toggle6 = this.toggle6.bind(this);
        this.state = { collapse1: false, collapse2: false, collapse3: false, collapse4: false, collapse5: false, collapse6: false };
    }

    toggle() {
        this.setState(state => ({ collapse1: !state.collapse1}));
    }
    toggle2() {
        this.setState(state => ({ collapse2: !state.collapse2 }));
    }
    toggle3() {
        this.setState(state => ({ collapse3: !state.collapse3 }));
    }
    toggle4() {
        this.setState(state => ({ collapse4: !state.collapse4 }));
    }
    toggle5() {
        this.setState(state => ({ collapse5: !state.collapse5 }));
    }
    toggle6() {
        this.setState(state => ({ collapse6: !state.collapse6 }));
    }

    render() {
        return (
            <div className={styles.accordion}>
                <div className={styles.box}>
                    <Button color="primary" onClick={this.toggle} className={styles.btn}><span> Consigo pesquisar um estabelecimento pelo nome e/ou endereço? </span> <img src={collapse} alt="FAQ" /> </Button>
                    <Collapse isOpen={this.state.collapse1}>
                        <Card className={styles.card}>
                            <CardBody>
                            Sim! Clique na caixa de pesquisa "o que você procura?" e digite o nome ou endereço, que os estabelecimentos serão listados (caso façam parte da rede credenciada).
                            </CardBody>
                        </Card>
                    </Collapse>
                </div>
                <div className={styles.box}>
                    <Button color="primary" onClick={this.toggle2} className={styles.btn}><span> Quero buscar os estabelecimentos por categoria (exemplo: Farmácias). É possível?</span> <img src={collapse} alt="FAQ" /></Button>
                    <Collapse isOpen={this.state.collapse2}>
                        <Card className={styles.card}>
                            <CardBody>
                            Sim. Criamos uma opção "Categorias" que está visível na parte inferior da tela do aplicativo. Basta arrastar a área para cima e selecionar a categoria desejada!
                            </CardBody>
                        </Card>
                    </Collapse>
                </div>
                {/* <div className={styles.box}>
                    <Button color="primary" onClick={this.toggle3} className={styles.btn}><span> É possível acessar as últimas pesquisas realizadas?</span><img src={collapse} alt="FAQ" /></Button>
                    <Collapse isOpen={this.state.collapse3}>
                        <Card className={styles.card}>
                            <CardBody>
                            Sim, é possível! Basta clicar na caixa de pesquisa "O que você procura", que as últimas pesquisas realizadas estarão listadas para acesso rápido
                            </CardBody>
                        </Card>
                    </Collapse>
                </div> */}
                <div className={styles.box}>
                    <Button color="primary" onClick={this.toggle4} className={styles.btn}><span> Achei um estabelecimento que eu quero ir! Consigo traçar uma rota até lá?</span><img src={collapse} alt="FAQ" /></Button>
                    <Collapse isOpen={this.state.collapse4}>
                        <Card className={styles.card}>
                            <CardBody>
                            Sim, esta opção está disponível visualizando os detalhes do estabelecimento, e clicando na opção "ir", que irá direcionar você até o estabelecimento, usando o aplicativo Google Maps ou Waze!
                            </CardBody>
                        </Card>
                    </Collapse>
                </div>
                <div className={styles.box}>
                    <Button color="primary" onClick={this.toggle5} className={styles.btn}><span> Consigo guardar os meus estabelecimentos preferidos?</span><img src={collapse} alt="FAQ" /></Button>
                    <Collapse isOpen={this.state.collapse5}>
                        <Card className={styles.card}>
                            <CardBody>
                            Claro! Você pode adicionar os seus estabelecimentos preferidos na seção Favoritos. Esta opção está disponível ao visualizar os detalhes do estabelecimento pesquisado. 
                            </CardBody>
                        </Card>
                    </Collapse>
                </div>
                {/* <div className={styles.box}>
                    <Button color="primary" onClick={this.toggle6} className={styles.btn}><span> Estou sem conexão à internet. Consigo utilizar o aplicativo?</span><img src={collapse} alt="FAQ" /></Button>
                    <Collapse isOpen={this.state.collapse6}>
                        <Card className={styles.card}>
                            <CardBody>
                            Sim! O aplicativo está programado para guardar os dados dos estabelecimentos credenciados próximos a ti para acesso offline. É possível configurar os parâmetros de carga da base de dados offline acessando o menu (opção Busca Offline).
                            </CardBody>
                        </Card>
                    </Collapse>
                </div> */}
            </div>
            );
        }
    }

export default FAQ;